module.exports = __webpack_public_path__ + "03_bob_black.e6377363.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_bob_black.png
// module id = itwF
// module chunks = 0